package com.timacookies.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.timacookies.Language
import com.timacookies.Loc
import com.timacookies.components.widgets.IconButton
import com.timacookies.currentLanguage
import com.timacookies.localizedStrings
import com.timacookies.toSitePalette
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.onAnimationEnd
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val NavHeaderStyle = CssStyle.base {
  Modifier
    .fillMaxWidth()
    .padding(topBottom = 1.5.cssRem, leftRight = 5.percent)
    .position(Position.Fixed)
    .top(0.px)
    .zIndex(10)
    .backgroundColor(
      colorMode
        .toPalette()
        .background
        .toRgb()
        .copyf(alpha = 0.8f),
    ).backdropFilter(blur(10.px))
}

@Composable
private fun NavLink(
  path: String,
  text: String,
) {
  Link(
    path,
    text,
    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
    modifier = Modifier
      .fontFamily("Montserrat", "sans-serif")
      .fontSize(0.9.cssRem)
      .fontWeight(FontWeight.Light)
      .letterSpacing(0.2.cssRem)
      .textTransform(TextTransform.Uppercase),
  )
}

@Composable
private fun MenuItems() {
  val strings = localizedStrings()
  val lang = currentLanguage()
  NavLink(Loc.path(lang, "/"), strings.navHome)
//  NavLink(Loc.path(lang, "/creations"), strings.navCreations)
}

@Composable
private fun LanguageSwitcher() {
  val currentLanguage = currentLanguage()
  val ctx = rememberPageContext()

  Row(
    Modifier
      .gap(0.5.cssRem)
      .fontFamily("Montserrat")
      .fontSize(0.8.cssRem)
      .fontWeight(FontWeight.Light),
  ) {
    SpanText(
      "EN",
      Modifier
        .cursor(Cursor.Pointer)
        .opacity(if (currentLanguage == Language.EN) 1.0 else 0.4)
        .onClick {
          val subPath =
            window.location.pathname
              .removePrefix("/en")
              .removePrefix("/de")
          ctx.router.tryRoutingTo(Loc.path(Language.EN, subPath))
        },
    )
    SpanText("|", Modifier.opacity(0.2))
    SpanText(
      "DE",
      Modifier
        .cursor(Cursor.Pointer)
        .opacity(if (currentLanguage == Language.DE) 1.0 else 0.4)
        .onClick {
          val subPath =
            window.location.pathname
              .removePrefix("/en")
              .removePrefix("/de")
          ctx.router.tryRoutingTo(Loc.path(Language.DE, subPath))
        },
    )
  }
}

@Composable
private fun ColorModeButton() {
  var colorMode by ColorMode.currentState
  IconButton(onClick = { colorMode = colorMode.opposite }) {
    if (colorMode.isLight) MoonIcon() else SunIcon()
  }
  Tooltip(
    ElementTarget.PreviousSibling,
    "Toggle color mode",
    placement = PopupPlacement.BottomRight,
  )
}

@Composable
private fun HamburgerButton(onClick: () -> Unit) {
  IconButton(onClick) {
    HamburgerIcon()
  }
}

@Composable
private fun CloseButton(
  onClick: () -> Unit,
  modifier: Modifier = Modifier,
) {
  IconButton(onClick = onClick, modifier = modifier) {
    CloseIcon()
  }
}

val SideMenuSlideInAnim = Keyframes {
  from {
    Modifier.translateY((-100).percent)
  }

  to {
    Modifier
  }
}

// Note: When the user closes the side menu, we don't immediately stop rendering it (at which point it would disappear
// abruptly). Instead, we start animating it out and only stop rendering it when the animation is complete.
enum class SideMenuState {
  CLOSED,
  OPEN,
  CLOSING,
  ;

  fun close() =
    when (this) {
      CLOSED -> CLOSED
      OPEN -> CLOSING
      CLOSING -> CLOSING
    }
}

@Composable
fun NavHeader() {
  val language = currentLanguage()
  Row(NavHeaderStyle.toModifier(), verticalAlignment = Alignment.CenterVertically) {
    Link("/${language.code}", variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)) {
      Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.gap(1.cssRem)) {
        SpanText(
          "TIMA COOKIES",
          Modifier
            .fontFamily("Noto Serif Display")
            .fontSize(1.5.cssRem)
            .fontWeight(FontWeight.Bold)
            .letterSpacing(0.05.cssRem),
        )
      }
    }

    Spacer()

    Row(
      Modifier.gap(2.cssRem).displayIfAtLeast(Breakpoint.MD),
      verticalAlignment = Alignment.CenterVertically,
    ) {
      MenuItems()
      LanguageSwitcher()
      ColorModeButton()
    }

    Row(
      Modifier
        .fontSize(1.5.cssRem)
        .gap(1.cssRem)
        .displayUntil(Breakpoint.MD),
      verticalAlignment = Alignment.CenterVertically,
    ) {
      var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

      HamburgerButton(onClick = { menuState = SideMenuState.OPEN })

      if (menuState != SideMenuState.CLOSED) {
        SideMenu(
          menuState,
          close = { menuState = menuState.close() },
          onAnimationEnd = {
            if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED
          },
        )
      }
    }
  }
}

@Composable
private fun SideMenu(
  menuState: SideMenuState,
  close: () -> Unit,
  onAnimationEnd: () -> Unit,
) {
  Overlay(
    Modifier
      .zIndex(100)
      .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
      .onClick { close() },
  ) {
    key(menuState) {
      // Force recompute animation parameters when close button is clicked
      Column(
        Modifier
          .width(clamp(8.cssRem, 50.percent, 16.cssRem))
          .align(Alignment.TopEnd)
          // Close button will appear roughly over the hamburger button, so the user can close
          // things without moving their finger / cursor much.
          .padding(top = 2.cssRem, leftRight = 1.cssRem, bottom = 2.cssRem)
          .gap(1.5.cssRem)
          .backgroundColor(
            ColorMode.current
              .toSitePalette()
              .background.secondary,
          ).animation(
            SideMenuSlideInAnim.toAnimation(
              duration = 200.ms,
              timingFunction = if (menuState ==
                SideMenuState.OPEN
              ) {
                AnimationTimingFunction.EaseOut
              } else {
                AnimationTimingFunction.EaseIn
              },
              direction = if (menuState ==
                SideMenuState.OPEN
              ) {
                AnimationDirection.Normal
              } else {
                AnimationDirection.Reverse
              },
              fillMode = AnimationFillMode.Forwards,
            ),
          ).borderRadius(topLeft = 2.cssRem, bottomLeft = 2.cssRem)
          .onClick { it.stopPropagation() }
          .onAnimationEnd { onAnimationEnd() },
        horizontalAlignment = Alignment.End,
      ) {
        Column(
          Modifier
            .padding(right = 1.cssRem, left = 1.cssRem)
            .gap(1.5.cssRem)
            .fontSize(1.4.cssRem),
          horizontalAlignment = Alignment.CenterHorizontally,
        ) {
          CloseButton(
            modifier = Modifier.align(Alignment.End),
            onClick = { close() },
          )

          MenuItems()
          Link(
            path = "",
            text = localizedStrings().contactTitle,
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
            modifier = Modifier
              .fontFamily("Montserrat", "sans-serif")
              .fontSize(0.9.cssRem)
              .fontWeight(FontWeight.Light)
              .letterSpacing(0.2.cssRem)
              .textTransform(TextTransform.Uppercase)
              .onClick {
                close()
                window.scrollTo(0.0, document.documentElement?.scrollHeight?.toDouble() ?: 0.0)
              },
          )
          LanguageSwitcher()
          ColorModeButton()
        }
      }
    }
  }
}
